import { Element, Node } from 'slate';
import { RenderElementProps } from 'slate-react';
import { CustomEditor, CustomElement, ImageElement } from 'slate/types/slate';
import { DocumentImage } from './components/DocumentImage';

const isImage = (node: Node): node is ImageElement => Element.isElement(node) && node.type === 'image';

const withImage =
  (options: { readOnly?: boolean } = {}) =>
  (editor: CustomEditor) => {
    const { renderElement, isVoid } = editor;
    editor.isVoid = (element: CustomElement) => isImage(element) || isVoid(element);
    editor.renderElement = (props: RenderElementProps) => {
      if (isImage(props.element)) {
        return <DocumentImage {...props} element={props.element} readOnly={options.readOnly} />;
      } else {
        return renderElement(props);
      }
    };

    return editor;
  };

export default withImage;
